import { useState, useCallback, useRef } from 'react';
import { prepareZXingModule, readBarcodes } from 'zxing-wasm';
import { CameraVideoCanvas2, CameraVideoCanvasProps } from './CameraVideoCanvas2';

async function decodeBarcodeWasm(imageData: ImageData): Promise<string | null> {
  const results = await readBarcodes(imageData, {
    // Optionally specify formats for performance:
    formats: ['UPC-A', 'UPC-E', 'EAN-13', 'EAN-8', 'DataBar', 'DataBarExpanded', 'DataBarLimited',
      'Code128', 'ITF', 'Code39'],
    // Optionally add hints:
    // hints: { [DecodeHintType.TRY_HARDER]: true }
  });
  if (results.length > 0) {
    return results[0].text;
  }
  return null;
}

interface WasmBarcodeScannerProps {
  onLog?: (msg: string) => void;
  onCapture: (code: string) => void;
}

export const WasmBarcodeScanner2 = ({ onLog, onCapture }: WasmBarcodeScannerProps) => {
  const [scannedCode, setScannedCode] = useState<string>('');
  const lastScanTimeRef = useRef<number>(0);
  const pauseRef = useRef(false);

  prepareZXingModule({
    overrides: {
      locateFile: () => '/wasm/zxing_full.wasm',
    },
  });

  // Called by CameraVideoCanvas with each frame
  const handleFrame = useCallback(async (imageData: ImageData) => {
    if (pauseRef.current) return; // Skip if paused
    const now = Date.now();
    if (now - lastScanTimeRef.current < 75) return; // Throttle to every 75ms
    lastScanTimeRef.current = now;
    const result = await decodeBarcodeWasm(imageData);
    if (result) {

      if (result !== scannedCode) {
        setScannedCode(result);
        onLog?.(`Scanned: ${result}`);
      }

      onCapture(result);

      pauseRef.current = true;
      setTimeout(() => { pauseRef.current = false; }, 400); // Pause for 500ms
    } else {
      setScannedCode('');
    }
  }, [scannedCode, onLog]);

  return (
    <>
      <CameraVideoCanvas2
        onFrame={handleFrame}
        onLog={onLog}
      />
      <div>
        <strong>Last scanned code:</strong> {scannedCode}
      </div>
    </>
  );
};
